{
  "it": {
    "timestamp": {
      "labels": {
        "accepted": "Accettato il {date}",
        "ago": "fa",
        "daysAgo": "{days} giorno | {days} giorni",
        "daysRemaining": "{days} giorni rimanenti",
        "due": "Scade il {date}",
        "dueToday": "Scade oggi",
        "expired": "Scaduto il {date}",
        "hoursAgo": "{hours} ora | {hours} ore",
        "in": "Tra {time}",
        "justNow": "Proprio ora",
        "minutesAgo": "{minutes} minuto | {minutes} minuti",
        "monthsAgo": "{months} mese | {months} mesi",
        "noDeadline": "Nessuna scadenza impostata",
        "overdue": "In ritardo di {days} giorni",
        "sentOn": "Inviato il {date}",
        "sentOnAt": "Inviato il {date} alle {time}",
        "starts": "Inizia il {date}",
        "today": "Oggi",
        "tomorrow": "Domani",
        "uploaded": "Caricato il {date}",
        "weeksAgo": "{weeks} settimana | {weeks} settimane",
        "yearsAgo": "{years} anno | {years} anni",
        "yesterday": "Ieri"
      }
    }
  }
}
